export default "__VITE_ASSET__DTVmtUvH__"